// Port of api/fuel/app/classes/filter/search/games/filters/query/game/rating.php
import Util from 'offline/util'
import { rangeActive } from 'offline/filter/core/search/unit'
export default {
	name: 'game.rating',
	priority: 40,
	require: function(config, filter) {
		return rangeActive(filter.rating && filter.rating.community, 0, 10)
	},
	run: function(config, filter, data, query) {
		if (filter.rating.community.from > 0) {
			query.where('g.game_rating_avg', '>=', Util.adjustedRating(filter.rating.community.from))
		}
		if (filter.rating.community.to < 10) {
			query.where('g.game_rating_avg', '<=', Util.adjustedRating(filter.rating.community.to, true))
		}
		if (filter.threshold && filter.threshold.community) {
			query.where('g.game_rating_count', '>=', filter.threshold.community)
		}
	}
}
